import { useState, useEffect } from 'react';

const MESSAGES = [
  { icon: '☀', title: 'Calculando posições planetárias',  sub: 'Mapeando onde cada planeta estava no momento do seu nascimento' },
  { icon: '⬆', title: 'Determinando seu Ascendente',      sub: 'Sua personalidade externa e como você se apresenta ao mundo' },
  { icon: '⬡', title: 'Analisando as 12 casas astrológicas', sub: 'As 12 áreas da sua vida influenciadas pelos astros' },
  { icon: '✦', title: 'Interpretando aspectos planetários', sub: 'Como os planetas conversam entre si no seu mapa' },
  { icon: '🌙', title: 'Finalizando seu mapa natal',         sub: 'Preparando insights personalizados baseados no seu céu único' },
];

const TOTAL_MS = 40_000;
const STEP_MS  = TOTAL_MS / MESSAGES.length;

export function MapGeneratingLoader() {
  const [msgIdx,   setMsgIdx]   = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const msgTimer = setInterval(() => {
      setMsgIdx(i => (i < MESSAGES.length - 1 ? i + 1 : i));
    }, STEP_MS);
    return () => clearInterval(msgTimer);
  }, []);

  useEffect(() => {
    const tick = 200;
    const inc  = (tick / TOTAL_MS) * 100;
    const progressTimer = setInterval(() => {
      setProgress(p => Math.min(p + inc, 99));
    }, tick);
    return () => clearInterval(progressTimer);
  }, []);

  const msg = MESSAGES[msgIdx];

  return (
    <div style={{ textAlign: 'center', padding: '3rem 1.5rem' }}>
      {/* Animated icon */}
      <div style={{
        display:        'inline-flex',
        alignItems:     'center',
        justifyContent: 'center',
        width:   '6rem',
        height:  '6rem',
        borderRadius: '50%',
        background: 'var(--bg-elevated)',
        border: '1px solid var(--line-soft)',
        fontSize: '2.25rem',
        marginBottom: '1.75rem',
        animation: 'pulse 2s ease-in-out infinite',
      }}>
        {msg.icon}
      </div>

      <h3 style={{
        fontFamily: 'var(--font-display)',
        fontStyle:  'italic',
        fontWeight: 400,
        fontSize:   'var(--text-22)',
        color:      'var(--bg)',
        margin:     '0 0 0.5rem',
      }}>
        {msg.title}
      </h3>
      <p style={{
        color:        'var(--text-secondary)',
        fontSize:     'var(--text-label)',
        margin:       '0 0 2rem',
        lineHeight:   1.6,
        maxWidth:     '340px',
        marginInline: 'auto',
      }}>
        {msg.sub}
      </p>

      {/* Progress bar */}
      <div style={{
        maxWidth:     '320px',
        marginInline: 'auto',
        marginBottom: '0.75rem',
      }}>
        <div style={{
          width:        '100%',
          height:       '4px',
          borderRadius: '999px',
          background:   'var(--bg-elevated)',
          overflow:     'hidden',
        }}>
          <div style={{
            height:     '100%',
            width:      `${progress}%`,
            borderRadius: '999px',
            background:   'var(--petrol)',
            transition:   'width 0.2s linear',
          }} />
        </div>
      </div>
      <p style={{ fontSize: 'var(--text-caption)', color: 'var(--text-muted)' }}>
        {Math.round(progress)}% completo
      </p>

      {/* Fun fact */}
      <div style={{
        marginTop:  '2rem',
        padding:    '1rem 1.25rem',
        borderRadius: 'var(--radius-sm)',
        background: 'var(--bg-elevated)',
        border:     '1px solid var(--line-soft)',
        maxWidth:   '360px',
        marginInline: 'auto',
      }}>
        <p style={{ fontSize: 'var(--text-caption)', color: 'var(--text-secondary)', margin: 0, fontStyle: 'italic' }}>
          💡 Seu mapa astral é único. Mesmo gêmeos nascidos com minutos de diferença têm mapas distintos!
        </p>
      </div>

      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.6} }`}</style>
    </div>
  );
}
